export default __webpack_public_path__ + "static/media/Chestguard of the Vanguard.aa8609bf.jpg";